// extracted by mini-css-extract-plugin
module.exports = {"grid":"CourcesStyle_grid__8Z84e","card":"CourcesStyle_card___u0q3","detail":"CourcesStyle_detail__3XGj9"};